import { useState } from 'react';
import PropTypes from 'prop-types';

import Button from '@mui/material/Button';

import GeneralInfo from './generalInfo/GeneralInfo';
import AlternateEmails from './alternateEmails/AlternateEmails';
import ConfirmPassword from './confirmPassword/ConfirmPassword';

import { saveSettings } from 'store/myAccount-actions';

import classes from './PersonalInfo.module.css';

const PersonalInfo = props => {
  const [changesBtn, setChangesBtn] = useState(false);
  const [updateAlias, setUpdateAlias] = useState([]);
  const [updateName, setUpdateName] = useState('');
  const [updateLastName, setUpdateLastName] = useState('');
  const [updateEmail, setUpdateEmail] = useState('');
  const [success, setSuccess] = useState(false);
  const [openDialogPassword, setOpenDialogPassword] =
    useState(false);

  const updateAliasHandler = alias => {
    setUpdateAlias([...updateAlias, alias]);
  };

  const showConfirmPassword = () => {
    setOpenDialogPassword(!openDialogPassword);
    setSuccess(false);
  };

  const updateGeneralInfoHandler = (param, value) => {
    if (param === 'name') {
      setUpdateName(value);
    } else if (param === 'lastName') {
      setUpdateLastName(value);
    } else {
      setUpdateEmail(value);
    }
  };

  const changesHandler = param => {
    setChangesBtn(param);
  };

  const saveHandler = () => {
    const updateData = {};
    if (updateEmail !== props.userData.email) {
      const newEmailData = {
        data: updateEmail,
        action: 'UPDATE'
      };
      updateData.email = newEmailData;
    }
    if (updateName !== props.userData.name) {
      const newNameData = {
        data: updateName,
        action: 'UPDATE'
      };
      updateData.nombre = newNameData;
    }
    if (updateLastName !== props.userData.lastName) {
      const newLastNameData = {
        data: updateLastName,
        action: 'UPDATE'
      };
      updateData.apellido = newLastNameData;
    }
    if (Object.keys(updateAlias).length !== 0) {
      updateData.aliasDetails = updateAlias;
    }
    (async () => {
      setSuccess(await saveSettings(updateData));
    })();
  };

  return (
    <div className={classes.personalInfoContainer}>
      <p className={classes.text}>Datos Personales:</p>
      <p className={classes.subtext}>
        Tus nombres y apellidos aparecerán en tus diplomas futuros
        tal como los captures aquí
      </p>
      <GeneralInfo
        userData={props.userData}
        changeName={props.changeName}
        changesHandler={changesHandler}
        updateGeneralInfo={updateGeneralInfoHandler}
      />
      <AlternateEmails
        emails={props.userData.aliasDetails}
        changesHandler={changesHandler}
        updateAlias={updateAliasHandler}
      />
      <Button
        disabled={!changesBtn}
        onClick={showConfirmPassword}
        className={classes.saveBtn}
      >
        Guardar cambios
      </Button>
      {openDialogPassword && (
        <ConfirmPassword
          open={openDialogPassword}
          close={showConfirmPassword}
          save={saveHandler}
          success={success}
        />
      )}
    </div>
  );
};

PersonalInfo.propTypes = {
  // eslint-disable-next-line react/require-default-props
  userData: PropTypes.array,
  // eslint-disable-next-line react/require-default-props
  changeName: PropTypes.func
};

export default PersonalInfo;
